/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5408b3bc&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=5408b3bc&lang=css"

import exportComponent from "/Users/neo/Desktop/github.com/liuzemei/gongdehui-client2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5408b3bc"]])

export default __exports__